<template>
    <div class="service">
        <mt-header fixed title="自助下单">
            <router-link to="/self" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <div class="service-body">
                <mt-field label="*服务对象" v-model="elderName" disabled></mt-field>
                <mint-select selectLabel="*需求类别" selectPatch="type" :selectValue="type" :slots="typeSlots" @changeValue="changeValue"></mint-select>
                <mt-field label="*需求主题" placeholder="请输入需求主题" v-model="title"></mt-field>
                <mt-field label="*预期服务日期" placeholder="请输入预期服务日期" type="date" v-model="expected_time"></mt-field>

                <mt-field label="需求简述" placeholder="请输入需求简述" type="textarea" rows="3" v-model="desc"></mt-field>
                <div class="new-form-button">
                    <mt-button size="large" type="primary" @click="createSelf">提交</mt-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import mintSelect from '../components/mintSelect.vue'

    export default{

        components: {
            'mint-select':mintSelect
        },

        data(){
            return {

                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,

                elder:this.$route.query.elder,
                elderName:this.$route.query.elderName,

                title:'',
                expected_time:'',
                desc:'',

                type:'',
                typeSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

            }
        },

        methods:{

            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },

            createSelf(){

                let that = this;

                if(this.title===''||this.expected_time===''||this.type===''){
                    this.$toast('带*为必填项，请填写完整');
                    return false;
                }

                this.$indicator.open('加载中');

                this.$axios.post("/self", {openid:this.openid,type:this.type,title:this.title,expected_time:this.expected_time,desc:this.desc,elder:this.elder})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('下单成功！');
                            setTimeout(function(){
                                that.$router.push('/my/self');
                            },2000);
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            }
        },

        created(){

            this.$indicator.open('加载中');

            this.$axios.get("/self/type?openid="+this.openid)
                .then(data => {

                    this.$indicator.close();

                    if (data.data.code === 'OK') {
                        this.typeSlots[0].values = data.data.data;
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        }
    }
</script>

<style scoped>
    .service-header{
        padding:20px;
    }
    .service-header-info{
        display:flex;
        background:#fff;
        align-items: center;
        padding:10px 0;
        justify-content: center;
        border-radius:10px;
    }

    .service-header-img{
        width:15%;
    }

    .service-header-img img{
        width:100%;
    }


</style>


// WEBPACK FOOTER //
// src/pages/self2.vue